"use client";

import {useCallback, useEffect, useState} from "react";

export function useOnlineStatus() {
    const [online, setOnline] = useState(
        typeof navigator === 'undefined' ? true : navigator.onLine);

    const handle = useCallback(() => {
        setOnline(navigator.onLine);
    }, []);

    useEffect(() => {
        window.addEventListener("online", handle);
        window.addEventListener("offline", handle);
        return () => {
            window.removeEventListener("online", handle);
            window.removeEventListener("offline", handle);
        };
    }, [handle]);

    return online;
}
